import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation AnswerTemplates($id: Int) {
  deleteAnswerTemplate(id: $id) {
    id
    text
    value
  }
}`;

function deleteAnswerTemplate({ id }) {
  return apollo.client.mutate({
    mutation,
    variables: { id: parseInt(id, 10) },
  }).then((data) => data.data.deleteAnswerTemplate);
}

export default deleteAnswerTemplate;
